import { Avatar } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import { FC } from "react";
import { ReactComponent as EmailIcon } from "./assets/email.svg";

// Avatar for the Gmail channel: shows the provided image when available,
// otherwise the email icon (instead of name initials). Used in the conversation
// list rows, the top bar and the chat bubble.
export const EmailAvatar: FC<{
  className?: string;
  imageUrl?: string | null;
  username?: string;
  fallbackToInitials?: boolean;
}> = ({ className, imageUrl, username, fallbackToInitials = false }) => (
  <Avatar
    username={username ?? ""}
    imageUrl={imageUrl}
    size="md"
    icon={
      fallbackToInitials ? undefined : (
        <EmailIcon className="h-4 w-4 text-primary-800" />
      )
    }
    className={cx("shrink-0", className)}
  />
);
